// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticateRouteImport } from './routes/authenticate'
import { Route as BotRouteImport } from './routes/bot'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ComplaintsPolicyRouteImport } from './routes/complaints-policy'
import { Route as HowWeCompareAgentsRouteImport } from './routes/how-we-compare-agents'
import { Route as LandlordTermsRouteImport } from './routes/landlord-terms'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StartRouteImport } from './routes/start'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as AgentsAgentSlugRouteImport } from './routes/agents.$agentSlug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CompareSplatRouteImport } from './routes/compare.$'
import { Route as LettingAgentsIndexRouteImport } from './routes/letting-agents.index'
import { Route as LettingAgentsTownSlugRouteImport } from './routes/letting-agents.$townSlug'
import { Route as AuthAuthSignInRouteImport } from './routes/_auth/auth.sign-in'
import { Route as AuthenticatedStartSubmissionIdRouteImport } from './routes/_authenticated/start.$submissionId'
import { Route as AuthenticatedStartSubmissionIdIndexRouteImport } from './routes/_authenticated/start.$submissionId.index'
import { Route as AuthenticatedStartSubmissionIdReportRouteImport } from './routes/_authenticated/start.$submissionId.report'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthenticateRoute = AuthenticateRouteImport.update({
            id: '/authenticate',path: '/authenticate',getParentRoute: () => rootRouteImport
          })
const BotRoute = BotRouteImport.update({
            id: '/bot',path: '/bot',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ComplaintsPolicyRoute = ComplaintsPolicyRouteImport.update({
            id: '/complaints-policy',path: '/complaints-policy',getParentRoute: () => rootRouteImport
          })
const HowWeCompareAgentsRoute = HowWeCompareAgentsRouteImport.update({
            id: '/how-we-compare-agents',path: '/how-we-compare-agents',getParentRoute: () => rootRouteImport
          })
const LandlordTermsRoute = LandlordTermsRouteImport.update({
            id: '/landlord-terms',path: '/landlord-terms',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const AgentsAgentSlugRoute = AgentsAgentSlugRouteImport.update({
            id: '/agents/$agentSlug',path: '/agents/$agentSlug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CompareSplatRoute = CompareSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => CompareRoute
          })
const LettingAgentsIndexRoute = LettingAgentsIndexRouteImport.update({
            id: '/letting-agents/',path: '/letting-agents/',getParentRoute: () => rootRouteImport
          })
const LettingAgentsTownSlugRoute = LettingAgentsTownSlugRouteImport.update({
            id: '/letting-agents/$townSlug',path: '/letting-agents/$townSlug',getParentRoute: () => rootRouteImport
          })
const AuthAuthSignInRoute = AuthAuthSignInRouteImport.update({
            id: '/auth/sign-in',path: '/auth/sign-in',getParentRoute: () => AuthRoute
          })
const AuthenticatedStartSubmissionIdRoute = AuthenticatedStartSubmissionIdRouteImport.update({
            id: '/start/$submissionId',path: '/start/$submissionId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedStartSubmissionIdIndexRoute = AuthenticatedStartSubmissionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStartSubmissionIdRoute
          })
const AuthenticatedStartSubmissionIdReportRoute = AuthenticatedStartSubmissionIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AuthenticatedStartSubmissionIdRoute
          })





const AuthRouteChildren = {
  AuthAuthSignInRoute: AuthAuthSignInRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const AuthenticatedStartSubmissionIdRouteChildren = {
  AuthenticatedStartSubmissionIdReportRoute: AuthenticatedStartSubmissionIdReportRoute,AuthenticatedStartSubmissionIdIndexRoute: AuthenticatedStartSubmissionIdIndexRoute
}

const AuthenticatedStartSubmissionIdRouteWithChildren = AuthenticatedStartSubmissionIdRoute._addFileChildren(AuthenticatedStartSubmissionIdRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedStartSubmissionIdRoute: AuthenticatedStartSubmissionIdRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const CompareRouteChildren = {
  CompareSplatRoute: CompareSplatRoute
}

const CompareRouteWithChildren = CompareRoute._addFileChildren(CompareRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AuthRoute: AuthRouteWithChildren,AuthenticatedRoute: AuthenticatedRouteWithChildren,AuthenticateRoute: AuthenticateRoute,BotRoute: BotRoute,CompareRoute: CompareRouteWithChildren,ComplaintsPolicyRoute: ComplaintsPolicyRoute,HowWeCompareAgentsRoute: HowWeCompareAgentsRoute,LandlordTermsRoute: LandlordTermsRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SettingsRoute: SettingsRoute,StartRoute: StartRoute,TermsOfUseRoute: TermsOfUseRoute,AgentsAgentSlugRoute: AgentsAgentSlugRoute,BlogSlugRoute: BlogSlugRoute,LettingAgentsTownSlugRoute: LettingAgentsTownSlugRoute,BlogIndexRoute: BlogIndexRoute,LettingAgentsIndexRoute: LettingAgentsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)